import { ThemeProvider } from 'styled-components';
import { defaultTheme } from '@theme';
import React from 'react';
import { NativeBaseProvider } from 'native-base';

export const withUIProvider = (WrappedComponent: any) => {
    const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    const ProviderWrapper = () => {
        return (
            <ThemeProvider theme={defaultTheme}>
                <NativeBaseProvider>
                    <WrappedComponent />
                </NativeBaseProvider>
            </ThemeProvider>
        );
    };
    ProviderWrapper.displayName = displayName;
    return ProviderWrapper;
};
